import React from "react";
import { useNavigate } from "react-router-dom";
import AuthFormCard from "components/auth-form-card/AuthFormCard";
import AuthForm from "components/auth-form/AuthForm";
import LoadingModal from "modals/loading/LoadingModal";
import ErrorModal from "modals/error-modal/ErrorModal";
import { useLoginForm } from "./useLoginForm";
import { useSelector } from "react-redux";
import { networkTypeSelector } from "store/userSliceHelpers";

function LoginForm() {
  const navigate = useNavigate();
  const {
    fields,
    submitRef,
    isSubmitDisabled,
    showLoading,
    loadingMsg,
    showError,
    errorMsg,
    handleLogin,
    handleDummyLogin,
    handleCloseError,
  } = useLoginForm();

  const networkType = useSelector(networkTypeSelector);

  return (
    <>
      <AuthFormCard
        title="Welcome back"
        subtitle="Sign in to your Kea Valley account"
      >
        <AuthForm
          fields={fields}
          submitLabel="Sign in"
          onSubmit={networkType === "mainnet" ? handleLogin : handleDummyLogin}
          disabled={isSubmitDisabled}
          isLoading={showLoading}
          submitRef={submitRef}
        />

        {networkType === "mainnet" && (
          <p className="v1-auth-nav">
            <button
              className="v1-auth-nav-link"
              type="button"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot password?
            </button>
          </p>
        )}

        {/* <p className="v1-auth-nav">
          Don&apos;t have an account?{" "}
          <button
            className="v1-auth-nav-link"
            type="button"
            onClick={() => navigate("/signup")}
          >
            Sign up
          </button>
        </p> */}
      </AuthFormCard>

      <LoadingModal isOpen={showLoading} loadingMsg={loadingMsg} />

      <ErrorModal
        isOpen={showError}
        errorMsg={errorMsg}
        handleClose={handleCloseError}
        tryAgain={handleCloseError}
      />
    </>
  );
}

export default LoginForm;
